import React from 'react'
import { IMG_BASE_URL } from '../Helpers';
import { useLocation } from 'react-router-dom';
import SameAuthorBooks from './SameAuthorBooks';
import SEO from '../seo/SEO';              // Import SEO Component
import { getAuthorSEO } from '../seo/AuthorSEO'; // Import SEO Logic

export default function AuthorDetails({ author: propAuthor, bookId }) {

    const location = useLocation();
    const authorFromState = location.state?.author;
    const author = propAuthor || authorFromState;

    // Generate the Dynamic SEO Data
    const seoData = getAuthorSEO(author);

    return (
        <>
            <SEO {...seoData} />

            <span >
                <section className="py-5 " id="scroll-target">
                    <div className="container px-5 my-5">
                        <div className="row gx-5 ">
                            <div className="col-lg-2">
                                {/* Updated alt tag for SEO */}
                                <img className="img-fluid rounded mb-5 mb-lg-0" src={IMG_BASE_URL + "authors/" + author?.author_photo} alt={author?.author_name || "Author Photo"} />
                            </div>
                            <div className="col-lg-10">
                                <h5>Author Name : {author?.author_name}</h5>
                                <span dangerouslySetInnerHTML={{ __html: author?.biography }}></span>
                            </div>
                        </div>
                    </div>
                </section>
                <SameAuthorBooks authorId={author?.author_id} bookId={bookId} />
            </span>
        </>
    )
}